import { createTransform } from 'redux-persist';

// если начнется загрузка данных в любом из указанных данных и при этом обновиться страницу,
// то загрузка не возоновится, потому что isFetching будет true. А тут мы это меняем
export const FiltersDataTransform = createTransform(
    (inboundState, key) => {
        return { ...inboundState, isFetching: false };
    },
    (outboundState, key) => {
        return { ...outboundState, isFetching: false };
    },
    {
        whitelist: [
            'user',
            'AllFOIVCategories',
            'AllFOIVThemes',
            'lawsCategories',
            'lawsThemes',
            'lawsDoctypes',
            'lawsProjects',
            'lawsNPAs',
            'lawsDeadlinesLost',
            'lawsDeadlines',
            'lawsSources',
            'unitedCardPND',
            'unitedCardReestr',
        ],
    }
);

export const ActiveFeedTransform = createTransform(
    (inboundState, key) => {
        return { ...inboundState, lawsScroll: 0 };
    },
    (outboundState, key) => {
        return { ...outboundState, lawsScroll: 0 };
    },
    { whitelist: ['activeFeed'] }
);

export default FiltersDataTransform;



// WEBPACK FOOTER //
// ./src/redux_related/transforms.js